import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import styles from './Accuracy.module.scss';
import ButtonPrimary from "../../../components/button-primary/ButtonPrimary";

import Count from '../../../static/icons/count.svg';
import InformationIcon from '../../../static/icons/information.svg';
import AssistantIcon from '../../../static/icons/assistant.svg';
import DataIcon from '../../../static/icons/data.svg';
import {VEDMARKET_LINKS} from '../../../constants';

function Accuracy() {
  return (
      <div className={styles.accuracy}>
        <Container className={styles.accuracyContainer}>
          <Row>
            <Col xl={6}>
              <h1 className={styles.title}>
                Уникальная система обеспечивает высокую точность расчета
              </h1>
              <ButtonPrimary href={VEDMARKET_LINKS.calculator} target="_blank" rel="noreferrer" label="Перейти к расчетам" isWide className={styles.buttonTop}/>
            </Col>
            <Col lg={6} className={styles.countContainerColumn}>
              <div className={styles.countContainer}>
                <img src={Count} className={styles.count} alt=""/>
              </div>
              <p className={styles.countDescription}>
                * точность прогноза зависит от&nbsp;полноты введенных данных
              </p>
            </Col>
          </Row>
          <div className={styles.cardsContainer}>
            <Row>
              <Col xl={4}>
                <div className={styles.card}>
                  <img src={InformationIcon} className={styles.icon} alt=""/>
                  <p className={styles.text}>
                    Информация собирается и&nbsp;обрабатывается в&nbsp;режиме реального времени, в&nbsp;том числе с&nbsp;помощью искусственного интеллекта и&nbsp;машинного обучения.
                  </p>
                </div>
              </Col>
              <Col xl={4}>
                <div className={styles.card}>
                  <img src={AssistantIcon} className={styles.icon} alt=""/>
                  <p className={styles.text}>
                    Цифровой ассистент помогает подобрать ТН&nbsp;ВЭД коды и&nbsp;категорию товара, находит все необходимые данные и&nbsp;использует их&nbsp;в&nbsp;расчете.
                  </p>
                </div>
              </Col>
              <Col xl={4}>
                <div className={styles.card}>
                  <img src={DataIcon} className={styles.icon} alt=""/>
                  <p className={styles.text}>
                    Актуальные данные о&nbsp;стоимости доставки, таможенных пошлинах, сертификации поступают непосредственно от&nbsp;компаний-партнеров.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
          <Row>
            <Col xl={3}>
              <ButtonPrimary href={VEDMARKET_LINKS.calculator} target="_blank" rel="noreferrer" label="Перейти к расчетам" isWide className={styles.buttonBottom}/>
            </Col>
          </Row>
        </Container>
      </div>
  );
}

export default Accuracy;
